import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

export function useRedirectUrl() {
  const navigate = useNavigate()
  const defaultPath = '/'

  const getStoredUrl = useCallback(() => {
    return localStorage.getItem('redirectUrl') || defaultPath
  }, [])

  const clearStoredUrl = useCallback(() => {
    localStorage.removeItem('redirectUrl')
  }, [])

  const redirectToStoredUrl = useCallback(() => {
    const url = getStoredUrl()
    clearStoredUrl()
    navigate(url)
  }, [navigate, getStoredUrl, clearStoredUrl])

  const storeCurrentUrlAndRedirect = useCallback((redirectTo: string) => {
    const currentPath = window.location.pathname + window.location.search
    if (currentPath !== redirectTo) {
      localStorage.setItem('redirectUrl', currentPath)
    }
    navigate(redirectTo)
  }, [navigate])

  const navigateToSettings = useCallback(() => {
    navigate('/settings')
  }, [navigate])

  return {
    getStoredUrl,
    clearStoredUrl,
    redirectToStoredUrl,
    storeCurrentUrlAndRedirect,
    navigateToSettings
  }
}